module.exports={
	"Form": "TestInstanceViewManifest",
	"Scope": "TestInstance-View",
	"Descriptors":
	{
		"TestInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestInstance-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestInstance-View-Identity",
				"Group": "TestInstance-View-Identity"
			}
		},
		"TestInstanceDetails.IDTestPlan":
		{
			"Name": "Test Plan",
			"Hash": "TestInstance-View-IDTestPlan",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "TestPlan",
				"SearchFields":
				[
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestInstance-View-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDLab":
		{
			"Name": "Lab",
			"Hash": "TestInstance-View-IDLab",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "Lab",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "TestInstance-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "TestInstance-View-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.IDLineItem":
		{
			"Name": "Line Item",
			"Hash": "TestInstance-View-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				],
				"ReadOnly": true
			}
		},
		"TestInstanceDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "TestInstance-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "TestInstance-View-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.EstimatedCompletionDate":
		{
			"Name": "Estimated Completion Date",
			"Hash": "TestInstance-View-EstimatedCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.ActualCompletionDate":
		{
			"Name": "Actual Completion Date",
			"Hash": "TestInstance-View-ActualCompletionDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.Status":
		{
			"Name": "Status",
			"Hash": "TestInstance-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.StatusMessage":
		{
			"Name": "Status Message",
			"Hash": "TestInstance-View-StatusMessage",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.SampleTestNumber":
		{
			"Name": "Sample Test Number",
			"Hash": "TestInstance-View-SampleTestNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.TestResult":
		{
			"Name": "Test Result",
			"Hash": "TestInstance-View-TestResult",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestInstance-View-Details",
				"Group": "TestInstance-View-Details"
			}
		},
		"TestInstanceDetails.IDTestInstance":
		{
			"Name": "IDTest Instance",
			"Hash": "TestInstance-View-IDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.GUIDTestInstance":
		{
			"Name": "GUIDTest Instance",
			"Hash": "TestInstance-View-GUIDTestInstance",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestInstance-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestInstance-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestInstance-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		},
		"TestInstanceDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestInstance-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "TestInstance-View-DataAudit",
				"Group": "TestInstance-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestInstance-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestInstance-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestInstance-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestInstance-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestInstance-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestInstance-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
